<!--
 * @title: 规划期指标统计
 * @fileName: index
 * @projectName WEB
 * @author ：yaaynn
 * @date ：2020/6/2 11:01
 * @modified By：
 * @version:     1.0$
 * @description: TODO
-->
<template>
    <d2-container>
        <page-body v-show="!dialogShow"
                   :page-size="paging.limit"
                   :total="paging.total"
                   :current-page="paging.page"
                   @size-change="onPagingSizeChange"
                   @current-change="onPagingCurrentLimitChange">
            <template v-slot:default>
                <page-table
                        :buttons="buttons"
                        :table-column-attributes="pageConfig.tableColumnAttributes"
                        :value="tableData"
                        :toolbar-buttons="toolbarButtons"
                        :loading="loading"
                        @search-click="onSearch"
                        @add-click="onAdd"
                        @look-click="onLook"
                        @update-click="onUpdate"
                        @delete-click="onDelete"
                        :handle-column="true"
                >
                    <template v-slot:advanced-search>
                        <popover-form :form-config="searchConfig" v-model="search" @onSubmit="onSearch"></popover-form>
                    </template>
                </page-table>
            </template>
        </page-body>
        <page-edit-layout v-model="dialogValue" v-show="dialogShow">
            <template v-slot:button>
                <div class="common-flex-center-end">
                    <el-button type="primary" @click="dialogShow = false">返回</el-button>
                </div>
            </template>
            <template v-slot>
                <divider title="基础数据"></divider>
                <dynamic-form ref="dialogValue" :disabled="true" :form-config="dialogFormConfig" v-model="dialogValue"></dynamic-form>
                <!-- <divider title="明细信息"></divider>
                <div style="height: 25%;">
                    <page-table
                            :buttons="buttons"
                            :table-column-attributes="pageConfig.conservationTableColumnAttributes"
                            :value="pageConfig.conservationTableData"
                            :show-table-toolbar="false"
                            :loading="loading"
                            :handle-column="false"
                    >
                    </page-table>
                </div> -->
                <!-- <divider title="图示"></divider>
                <div style="height: 420px;" v-if="dialogShow" class="breaking-rate-eacharts-container">
                    <ve-histogram :data="pageConfig.chartData"></ve-histogram>
                </div> -->
            </template>
        </page-edit-layout>
    </d2-container>
</template>

<script>
    import PageBody from "@/components/Pages/PageBody";
    import PageTable from "@/components/Pages/PageTable/index";
    import PageEditLayout from "@/components/Pages/layout/PageEditLayout";

    export default {
        name: "index",
        components: {PageTable, PageBody, PageEditLayout},
        data() {
            return {
                //分页
                paging: {},
                //搜索数据
                search: {routeCode:""},
                //表格数据
                tableData: [],
                //页面配置
                pageConfig: {
                    // 表格列属性
                    tableColumnAttributes: [
                        {label: '规划批次名称', prop: 'planningName', type: 'String', width: 'auto', children: []},
                        {label: '规划路线编码', prop: 'routeCode', type: 'String', width: 'auto', children: []},
                        {label: '规划路线名称', prop: 'routeName', type: 'String', width: 'auto', children: []},
                        {label: '规划类型', prop: 'planningType', type: 'String', width: 'auto', children: []},
                        {label: '分析年度', prop: 'annual', type: 'String', width: 'auto', children: []},
                        {label: '行车方向', prop: 'drivingDirection', type: 'String', width: 'auto', children: []},
                        {label: 'PQI', prop: 'pqi', type: 'String', width: 'auto', children: []},
                        {label: 'PCI', prop: 'pci', type: 'String', width: 'auto', children: []},
                        {label: '优良路率(%)', prop: 'fineRate', type: 'String', width: 'auto', children: []},
                        {label: 'PQI<90路段所占比例(%)', prop: 'pqI90', type: 'String', width: 'auto', children: []},
                        {label: 'PQI<70路段所占比例(%)', prop: 'pqI70', type: 'String', width: 'auto', children: []},
                        {label: '预防性养护比例(%)', prop: 'preventiveMaintenanceRatio', type: 'String', width: 'auto', children: []},
                        {label: '结构/功能养护比例(%)', prop: 'maintenanceRatio', type: 'String', width: 'auto', children: []},
                    ],
                    // 养护表
                    // conservationTableColumnAttributes: [
                    //     {label: '行车方向', prop: 't_2', type: 'String', width: 'auto', children: []},
                    //     {
                    //         label: '规划期末', prop: 't_3', type: 'String', width: 'auto', children: [
                    //             {label: 'PQI', prop: 't_2', type: 'String', width: 'auto', children: []},
                    //             {label: 'PCI', prop: 't_2', type: 'String', width: 'auto', children: []},
                    //             {label: '优良路率(%)', prop: 't_2', type: 'String', width: 'auto', children: []},
                    //             {label: 'PQI<90路段所占比例(%)', prop: 't_2', type: 'String', width: 'auto', children: []},
                    //             {label: 'PQI<70路段所占比例(%)', prop: 't_2', type: 'String', width: 'auto', children: []},
                    //         ]
                    //     },
                    //     {label: '预防性养护比例(%)', prop: 't_3', type: 'String', width: 'auto', children: []},
                    //     {label: '大中修养护比例(%)', prop: 't_3', type: 'String', width: 'auto', children: []},
                    // ],
                    // conservationTableData: [],
                    chartData: {
                        columns: ['日期', '访问用户', '下单用户', '下单率'],
                        rows: [
                            {'日期': '1/1', '访问用户': 1393, '下单用户': 1093, '下单率': 0.32},
                            {'日期': '1/2', '访问用户': 3530, '下单用户': 3230, '下单率': 0.26},
                            {'日期': '1/3', '访问用户': 2923, '下单用户': 2623, '下单率': 0.76},
                            {'日期': '1/4', '访问用户': 1723, '下单用户': 1423, '下单率': 0.49},
                            {'日期': '1/5', '访问用户': 3792, '下单用户': 3492, '下单率': 0.323},
                            {'日期': '1/6', '访问用户': 4593, '下单用户': 4293, '下单率': 0.78}
                        ]
                    }
                },
                // 工具栏按钮
                toolbarButtons: 0,
                // 表格加载
                loading: false,
                // 查看模式
                lookModel: false, 
                // 弹出层数据
                dialogValue: {
                    planningName:"",/// 规划名称
                    planningType:"",/// 规划类型
                    routeName:"",/// 路线编码/路网编码
                    routeCode:"",/// 路线名称/路网名称
                    annual:"",/// 分析年度
                    drivingDirection:"",/// 行车方向
                    fineRate:"",/// 优良路率（%）
                    pqi:"",///规划期末PQI
                    pci:"",///规划期末PCI
                    pqi90:"",///规划期末PQI<90路段所占比例
                    pqi70:"",///规划期末PQI<70路段所占比例
                    preventiveMaintenanceRatio:"",///预防性养护比例（%）
                    maintenanceRatio:"",/// 大中修养护比例（%）
                },
                //搜索框配置
                searchConfig: {
                    "list": [{
                        "type": "input",
                        "icon": "icon-input",
                        "options": {
                            "width": "100%",
                            "defaultValue": "",
                            "required": false,
                            "dataType": "string",
                            "pattern": "",
                            "placeholder": "请输入路线编码",
                            "disabled": false,
                            "remoteFunc": "func_1590921615000_8607"
                        },
                        "name": "路线编码",
                        "key": "routeCode",
                        "model": "routeCode",
                        "rules": [{"type": "string", "message": "路线编码格式不正确"}]
                    }], "config": {"labelWidth": 100, "labelPosition": "right", "size": "small", "customClass": ""}
                },
                // 弹出层表单配置
                dialogFormConfig: {
                    "list": [{
                        "type": "input",
                        "icon": "icon-input",
                        "options": {
                            "width": "100%",
                            "defaultValue": "",
                            "required": false,
                            "dataType": "string",
                            "pattern": "",
                            "placeholder": "系统自动生成",
                            "disabled": true,
                            "remoteFunc": "func_1591067993000_98495"
                        },
                        "name": "规划批次名称",
                        "key": "1591068099000_66773",
                        "model": "planningName",
                        "rules": [{"type": "string", "message": "规划批次名称格式不正确"}]
                    }, {
                        "type": "input",
                        "icon": "icon-input",
                        "options": {
                            "width": "100%",
                            "defaultValue": "",
                            "required": false,
                            "dataType": "string",
                            "pattern": "",
                            "placeholder": "系统自动生成",
                            "disabled": true,
                            "remoteFunc": "func_1591067993000_98495"
                        },
                        "name": "规划路线编码",
                        "key": "1591068112000_76138",
                        "model": "routeCode",
                        "rules": [{"type": "string", "message": "规划路线编码格式不正确"}]
                    }, {
                        "type": "input",
                        "icon": "icon-input",
                        "options": {
                            "width": "100%",
                            "defaultValue": "",
                            "required": false,
                            "dataType": "string",
                            "pattern": "",
                            "placeholder": "系统自动生成",
                            "disabled": true,
                            "remoteFunc": "func_1591067993000_98495"
                        },
                        "name": "规划路线名称",
                        "key": "1591068120000_76634",
                        "model": "routeName",
                        "rules": []
                    }, {
                        "type": "input",
                        "icon": "icon-input",
                        "options": {
                            "width": "100%",
                            "defaultValue": "",
                            "required": false,
                            "dataType": "string",
                            "pattern": "",
                            "placeholder": "系统自动生成",
                            "disabled": true,
                            "remoteFunc": "func_1591067993000_98495"
                        },
                        "name": "分析年度",
                        "key": "1591068120000_76634",
                        "model": "annual",
                        "rules": []
                    }, {
                        "type": "input",
                        "icon": "icon-input",
                        "options": {
                            "width": "100%",
                            "defaultValue": "",
                            "required": false,
                            "dataType": "string",
                            "pattern": "",
                            "placeholder": "系统自动生成",
                            "disabled": true,
                            "remoteFunc": "func_1591067993000_98495"
                        },
                        "name": "行车方向",
                        "key": "1591068120000_76634",
                        "model": "drivingDirection",
                        "rules": []
                    }, {
                        "type": "input",
                        "icon": "icon-input",
                        "options": {
                            "width": "100%",
                            "defaultValue": "",
                            "required": false,
                            "dataType": "string",
                            "pattern": "",
                            "placeholder": "系统自动生成",
                            "disabled": true,
                            "remoteFunc": "func_1591067993000_98495"
                        },
                        "name": "优良路率（%）",
                        "key": "1591068120000_76634",
                        "model": "fineRate",
                        "rules": []
                    }, {
                        "type": "input",
                        "icon": "icon-input",
                        "options": {
                            "width": "100%",
                            "defaultValue": "",
                            "required": false,
                            "dataType": "string",
                            "pattern": "",
                            "placeholder": "系统自动生成",
                            "disabled": true,
                            "remoteFunc": "func_1591067993000_98495"
                        },
                        "name": "规划期末PQI",
                        "key": "1591068120000_76634",
                        "model": "pqi",
                        "rules": []
                    }, {
                        "type": "input",
                        "icon": "icon-input",
                        "options": {
                            "width": "100%",
                            "defaultValue": "",
                            "required": false,
                            "dataType": "string",
                            "pattern": "",
                            "placeholder": "系统自动生成",
                            "disabled": true,
                            "remoteFunc": "func_1591067993000_98495"
                        },
                        "name": "规划期末PCI",
                        "key": "1591068120000_76634",
                        "model": "pci",
                        "rules": []
                    }, {
                        "type": "input",
                        "icon": "icon-input",
                        "options": {
                            "width": "100%",
                            "defaultValue": "",
                            "required": false,
                            "dataType": "string",
                            "pattern": "",
                            "placeholder": "系统自动生成",
                            "disabled": true,
                            "remoteFunc": "func_1591067993000_98495"
                        },
                        "name": "PQI<90路段所占比例",
                        "key": "1591068120000_76634",
                        "model": "pqI90",
                        "rules": []
                    }, {
                        "type": "input",
                        "icon": "icon-input",
                        "options": {
                            "width": "100%",
                            "defaultValue": "",
                            "required": false,
                            "dataType": "string",
                            "pattern": "",
                            "placeholder": "系统自动生成",
                            "disabled": true,
                            "remoteFunc": "func_1591067993000_98495"
                        },
                        "name": "PQI<70路段所占比例",
                        "key": "1591068120000_76634",
                        "model": "pqI70",
                        "rules": []
                    }, {
                        "type": "input",
                        "icon": "icon-input",
                        "options": {
                            "width": "100%",
                            "defaultValue": "",
                            "required": false,
                            "dataType": "string",
                            "pattern": "",
                            "placeholder": "系统自动生成",
                            "disabled": true,
                            "remoteFunc": "func_1591067993000_98495"
                        },
                        "name": "预防性养护比例（%）",
                        "key": "1591068120000_76634",
                        "model": "preventiveMaintenanceRatio",
                        "rules": []
                    }, {
                        "type": "input",
                        "icon": "icon-input",
                        "options": {
                            "width": "100%",
                            "defaultValue": "",
                            "required": false,
                            "dataType": "string",
                            "pattern": "",
                            "placeholder": "系统自动生成",
                            "disabled": true,
                            "remoteFunc": "func_1591067993000_98495"
                        },
                        "name": "结构/功能养护比例（%）",
                        "key": "1591068120000_76634",
                        "model": "maintenanceRatio",
                        "rules": []
                    }], "config": {"labelWidth": 100, "labelPosition": "right", "size": "small"}
                },
                // 弹出层控制属性
                dialogShow: false
            }
        },
        methods: {
            //分页大小变更事件
            onPagingSizeChange(size) {
                this.paging.setSize(size)
                this.refreshData(this.paging, this.search)
            },
            // 分页当前页变动事件
            onPagingCurrentLimitChange(current) {
                this.paging.setIndex(current)
                this.refreshData(this.paging, this.search)
            },
            // 搜索事件
            onSearch() {
                this.refreshData(this.paging, this.search);
            },
            // 新增
            onAdd() {
                this.dialogShow = true
            },
            // 查看
            onLook(row) {
                this.$http.post(this.$url.routeDecision.getperiodindexstatistics,{rowCode:row.rowCode}).then(res=>{
                    this.dialogShow = true;
                    this.dialogValue=res.data[0];
                    // if(res.data[0].sublist){
                    //     this.pageConfig.detailsTableData=res.data[0].sublist;
                    // }else{
                    //     this.pageConfig.detailsTableData=[];
                    // }
                })
            },
            // 修改
            onUpdate() {

            },
            // 删除
            onDelete() {

            },
            initial() {
                this.refreshData(this.paging)
            },
            // 刷新数据
            refreshData(paging, search, callback) {
                const searchData = this.Tools.get().ObjectTools.merge(paging, search),
                    url = this.$url.routeDecision.getperiodindexstatistics
                // 由于web storm模板影响 请自行配置以下代码
                this.loading = true
                this.$http.post(url, searchData).then(res=>{
                    this.tableData=res.data;
                    this.paging.total = res.pageCount;
                    this.loading = false
                }).catch(error=>{
                    this.loading = false
                })
            },
        },
        computed: {
            // 表格按钮
            buttons() {
                return this.ButtonEnums.TableButtons.descriptionButton
            }
        },
        mounted() {
            this.paging = this.Paging.default()
            this.initial()
        }
    }
</script>

<style scoped lang="scss">

</style>

<vue-filename-injector>
export default function (Component) {
  Component.options.__source = "src/views/decision/PavementMaintenancePlanningScheme/IndicatorsDuringThePlanningPeriod/index.vue"
}
</vue-filename-injector>
